import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';



@Component({
  name: 'NovoDependentePopup',
  components: {
    TkForm,
  },
})
class NovoDependentePopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: undefined })
  private readonly overrideSaveAction: (internalRow: any) => any;

  @Prop({ default: null })
  private readonly row: any;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly defaultRow: any = {
    CDPAIS: '0055',
    SGESTADO: null,
    NRTIPORELACIONA: null,
    NRNACIONALID: '1',
  };

  private internalValue = false;

  private internalLoading = {
    tiposDependente: false,
    tiposRelacionamento: false,
    paises: false,
    estados: false,
    municipios: false,
    nacionalidades: false,
    estadosCivis: false,
  };

  private internalRow: any = {};

  private fieldsData = {
    estadosCivis: [],
    nacionalidades: [],
    paises: [],
    estados: [],
    municipios: [],
    tiposRelacionamento: [],
    tiposDependente: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.internalLoading);
    const internalLoading = Util.oneTrue(...loadingValues);

    const loading = internalLoading || this.loading;

    return loading;
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NMPESSOA',
        label: 'Nome',
        type: 'text',
        size: 8,
        required: true,
      },
      {
        name: 'DTNASCIFUNDPARC',
        label: 'Data de Nascimento',
        type: 'date',
        size: 4,
      },
      {
        name: 'IDSEXOPESSOA',
        label: 'Sexo',
        type: 'select',
        size: 4,
        required: true,
        descriptionField: 'DSSEXOPESSOA',
        valueField: 'IDSEXOPESSOA',
        outData: {
          IDSEXOPESSOA: 'IDSEXOPESSOA',
          DSSEXOPESSOA: 'DSSEXOPESSOA',
        },
        items: [
          {
            IDSEXOPESSOA: 'M',
            DSSEXOPESSOA: 'Masculino',
          },
          {
            IDSEXOPESSOA: 'F',
            DSSEXOPESSOA: 'Feminino',
          },
        ],
      },
      {
        name: 'CDESTACIVIL',
        label: 'Estado Civil',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'NMESTACIVIL',
        valueField: 'CDESTACIVIL',
        items: this.fieldsData.estadosCivis,
      },
      {
        name: 'NRNACIONALID',
        label: 'Nacionalidade',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'DSNACIONALIDADE',
        valueField: 'NRNACIONALIDADE',
        items: this.fieldsData.nacionalidades,
      },
      {
        name: 'CDPAIS',
        label: 'País',
        type: 'autocomplete',
        size: 4,
        descriptionField: 'NMPAIS',
        valueField: 'CDPAIS',
        items: this.fieldsData.paises,
        onInput: this.paisOnInput,
      },
      {
        name: 'SGESTADO',
        label: 'Estado',
        type: 'autocomplete',
        size: 4,
        readonly: !this.internalRow.CDPAIS,
        descriptionField: 'NMESTADO',
        valueField: 'SGESTADO',
        items: this.fieldsData.estados,
        onInput: this.estadoOnInput,
      },
      {
        name: 'CDMUNICIPIO',
        label: 'Município',
        type: 'autocomplete',
        size: 4,
        readonly:  !this.internalRow.CDPAIS || !this.internalRow.SGESTADO,
        descriptionField: 'NMMUNICIPIO',
        valueField: 'CDMUNICIPIO',
        items: this.fieldsData.municipios,
      },
      {
        name: 'NRTIPORELACIONA',
        label: 'Tipo de Relacionamento',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'NMTIPORELACIONA',
        valueField: 'NRTIPORELACIONA',
        outData: {
          NRTIPORELACIONA: 'NRTIPORELACIONA',
          NMTIPORELACIONA: 'NMTIPORELACIONA',
        },
        items: this.fieldsData.tiposRelacionamento,
      },
      {
        name: 'NRTIPODEPENDE',
        label: 'Tipo de Dependente',
        type: 'autocomplete',
        size: 6,
        required: this.tipoDependeIsRequired,
        descriptionField: 'NMTIPODEPENDE',
        valueField: 'NRTIPODEPENDE',
        items: this.fieldsData.tiposDependente,
      },
      {
        name: 'NRCPFPESSOA',
        label: 'CPF',
        type: 'text',
        mask: '###.###.###-##',
        required: this.cpfIsRequired,
        size: 3,
      },
      {
        name: 'DTFIMRELACIONAMENTO',
        label: 'Término do Relacionamento',
        type: 'date',
        size: 4,
      },
    ];

    return fields;
  }

  private get cpfIsRequired(): boolean {
    const nrTipoRel: string = this.internalRow.NRTIPORELACIONA;
    const tiposFilho = ['3', '100001'];

    const isRequired = tiposFilho.includes(nrTipoRel);

    return isRequired;
  }

  private get tipoDependeIsRequired(): boolean {
    const nrTipoRel: string = this.internalRow.NRTIPORELACIONA;
    const tiposNotRequired = ['1', '2'];

    const isRequired = !tiposNotRequired.includes(nrTipoRel);

    return isRequired;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.loadFields();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.row === null) {
        this.setDefaultRow();
      } else {
        this.internalRow = Util.deepCopy(this.row);
      }

      this.loadEstados();
      this.loadMunicipios();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private onSave() {
    if (!this.validate()) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    if (this.overrideSaveAction) {
      this.overrideSaveAction(this.internalRow);
    } else {
      this.save();
    }
  }

  private async save() {
    //
  }

  private loadFields() {
    this.loadTiposDependente();
    this.loadTiposRelacionamento();
    this.loadEstadosCivis();
    this.loadNacionalidades();
    this.loadPaises();
  }

  private async loadPaises() {
    this.internalLoading.paises = true;

    try {
      this.fieldsData.paises =
        await AdmissaoController.getPais(false);
    } finally {
      this.internalLoading.paises = false;
    }
  }

  private async loadEstados() {
    const cdPais: string = this.internalRow.CDPAIS;

    if (!cdPais) {
      return;
    }

    this.internalLoading.estados = true;

    try {
      this.fieldsData.estados =
        await AdmissaoController.getEstado(cdPais, false);
    } finally {
      this.internalLoading.estados = false;
    }
  }

  private async loadMunicipios() {
    const cdPais: string = this.internalRow.CDPAIS;
    const sgEstado: string = this.internalRow.SGESTADO;

    if (!cdPais || !sgEstado) {
      return;
    }

    this.internalLoading.municipios = true;

    try {
      this.fieldsData.municipios =
        await AdmissaoController.getMunicipio(cdPais, sgEstado, false);
    } finally {
      this.internalLoading.municipios = false;
    }
  }

  private async loadNacionalidades() {
    this.internalLoading.nacionalidades = true;

    try {
      this.fieldsData.nacionalidades =
        await AdmissaoController.getNacionalidade(false);
    } finally {
      this.internalLoading.nacionalidades = false;
    }
  }

  private async loadEstadosCivis() {
    this.internalLoading.estadosCivis = true;

    try {
      this.fieldsData.estadosCivis =
        await AdmissaoController.getEstadocivil(false);
    } finally {
      this.internalLoading.estadosCivis = false;
    }
  }

  private async loadTiposDependente() {
    this.internalLoading.tiposDependente = true;

    try {
      this.fieldsData.tiposDependente =
        await NovaSolicitacaoController.getTipoDependente(false);
    } finally {
      this.internalLoading.tiposDependente = false;
    }
  }

  private async loadTiposRelacionamento() {
    this.internalLoading.tiposRelacionamento = true;

    try {
      this.fieldsData.tiposRelacionamento =
        await NovaSolicitacaoController.getTipoRelacionamento(false);
    } finally {
      this.internalLoading.tiposRelacionamento = false;
    }
  }

  private setDefaultRow() {
    this.internalRow = Util.deepCopy(this.defaultRow);
  }

  private validate(): boolean {
    const isValid: boolean = (this.$refs.form as any).validate(true);

    return isValid;
  }

  private paisOnInput(cdPais: string) {
    this.internalRow.SGESTADO = null;
    this.internalRow.CDMUNICIPIO = null;

    this.loadEstados();
  }

  private estadoOnInput(sgEstado: string) {
    this.internalRow.CDMUNICIPIO = null;

    this.loadMunicipios();
  }
  // #endregion
}

export default NovoDependentePopup;
